import { Component } from '@angular/core'
import { FeatureFlagService } from '../shared/services/feature-flag.service'
import { AsyncPipe, CommonModule } from '@angular/common'
import { LoginComponent } from '../login/login.component'
import { LoginV2Component } from '../login-v2/login-component-v2.component'

@Component({
    selector: 'app-login-wrapper',
    templateUrl: './login-wrapper.component.html',
    imports: [AsyncPipe, CommonModule, LoginComponent, LoginV2Component],
})
export class LoginWrapperComponent {
    constructor(private featureFlagService: FeatureFlagService) {}

    isV2Enabled$ = this.featureFlagService.isLoginVariantTwo()
    isV1Enabled$ = this.featureFlagService.isLoginControlVariant()
}
